import React, { ReactNode, useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { AppProductType } from 'types';
import { useSampleData } from './hooks';

interface SampleMockTestsProps {
  productType: AppProductType;
  children: ReactNode;
}

const SampleMockTestsController = ({
  productType,
  children,
}: SampleMockTestsProps) => {
  const {
    mockTestId: mockTestIdFromParams,
    marksheetId: marksheetIdFromParams,
    markId,
    questionId,
  } = useParams<{
    mockTestId: string;
    marksheetId: string;
    markId?: string;
    questionId?: string;
  }>();

  const { marksheets } = useSampleData(
    productType,
    Boolean(mockTestIdFromParams)
  );

  const navigate = useNavigate();

  const [mockTestId, marksheetId] = useMemo(() => {
    if (mockTestIdFromParams && marksheetIdFromParams) {
      return [mockTestIdFromParams, marksheetIdFromParams];
    }

    const marksheetData = marksheets?.find(
      marksheet => marksheet.mockTestId !== null
    );

    return marksheetData
      ? [Number(marksheetData.mockTestId), Number(marksheetData.id)]
      : [undefined, undefined];
  }, [marksheetIdFromParams, marksheets, mockTestIdFromParams]);

  useEffect(() => {
    if (mockTestId && marksheetId) {
      navigate(
        `/sample/${productType}/mock-tests/test/${mockTestId}/${marksheetId}${
          markId && questionId ? `/${markId}/${questionId}` : ''
        }`
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productType, mockTestId, marksheetId]);

  return <>{children}</>;
};

export default SampleMockTestsController;
